import * as types from '../actions/actionTypes';
const Avatars = [
  '654348a084461e994dfa00a3',
  '65434d5dc91bc66cf7de81ae',
  '65434eeecc14c7b0c462cbee',
  '654a373b29a531c3e468283e',
  '654c7d15cb89ba26398ed220',
  '654c7c9bbb3be6ab35d27193',
  '655db2f9e88a425143910559',
  '655db273e88a4251439103da',
  '655de1cebb39d3a4464c1121',
  '65f7c5872cebbb1755b5d287',
  '654e09029b792809cd8a5762',
  '655b4ca11b3c8f493518a60d',
];

const randomItem = Avatars[Math.floor(Math.random() * Avatars.length)];

export const initialState = {
  direct_landing: false,
  joinMeetingStatus: false,
  avatarUrlValue: `https://models.readyplayer.me/${randomItem}.glb`,
  ready_to_move: false,
  showLeaveConfirmationModal: false,
  courseLeaveConfigs: {
    message: 'Are you sure you want to teleport to Quikbase?',
    portalType: 'exit_portal',
  },
  legacy: true,
  isQuikbase: false,
  customCourse: false,
};

const updateState = (state = initialState, action) => {
  switch (action.type) {
    case types.JOIN_MEETING: {
      return {...state, joinMeetingStatus: action.payload};
    }
    case types.SET_AVATAR_URL: {
      return {...state, avatarUrlValue: action.payload};
    }
    case types.SET_DIRECT_LANDING: {
      return {...state, direct_landing: action.payload};
    }
    case types.SET_READY_TO_MOVE: {
      return {...state, ready_to_move: action.payload};
    }
    case types.SET_SHOW_LEAVE_CONFIRMATION_MODAL: {
      return {...state, showLeaveConfirmationModal: action.payload};
    }
    case types.SET_COURSE_LEAVE_CONFIGS: {
      return {...state, courseLeaveConfigs: action.payload};
    }
    case types.SET_LEGACY_FLAG: {
      return {...state, legacy: action.payload};
    }
    case types.SET_IS_QUIKBASE: {
      return {...state, isQuikbase: action.payload};
    }
    case types.SET_CUSTOM_COURSE: {
      return {...state, customCourse: action.payload};
    }
    default:
      return state;
  }
};

export default updateState;
